<template>
  <!-- <div class="history-cover" v-show="showHistory"> -->
  <ui-modal
    :show="showHistory"
    type="tag"
    title="兑换记录"
    @close="showHistory = false"
  >
    <div class="history-box">
      <div class="inner" v-if="historyList && historyList.length != 0">
        <p v-for="(item, key) in historyList" :key="key">
          <img src="https://website.xdcdn.net/poster/58881/20250717/KwuBpcqu.png">
          {{
            `${formatDay(item?.createAt)}, 消耗 ${
              item?.cost * item?.num
            }竞猜币, 兑换商品【${item?.desc}】* ${item?.num}`
          }}
        </p>
        <div class="placeholder"></div>
      </div>
      <Interdict v-else tip="暂无兑换记录" hook="px" />
    </div>
  </ui-modal>
</template>

<script>
import * as api from "@/service/index";
import { mapState } from "vuex";
import UiModal from "@/components/ui-modal.vue";
import Interdict from '@/components/interdict';

export default {
  components: { UiModal, Interdict },
  data() {
    return {
      showHistory: false,
      inRequest: false,
      historyList: [],
    };
  },
  computed: {
    ...mapState(["scale", "token"]),
  },
  methods: {
    hideModal() {
      this.showHistory = false;
    },
    async history() {
      this.showHistory = true;

      if(!this.token) return;
      let data = {
        token: this.token,
      };
      let response = await api.reqStoreHistory(data);
      if (response.status == 200 ) {
        if(Array.isArray(response.data)){
          this.historyList = response.data
       }else{
          this.historyList = response.data.data
       }
      }
      // console.log(this.historyList);
    },

  
    formatDay(time) {
      const isoDateString = time.replace(" ", "T");
      let dateObj = new Date(isoDateString);
      let month = dateObj.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = dateObj.getDate();
      day = day < 10 ? "0" + day : day;

      return `${month}月${day}日`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/store/history";
</style>